<mat-card>
  <h1>
    ￥{{ data?.available_commission | number }}
    <mat-icon>currency_exchange</mat-icon>
  </h1>
  <h2>可用佣金</h2>
  <span>当前可以提现的金额</span>

  <button mat-stroked-button routerLink="/user/profile/affiliate/withdrawal">
    提现
  </button>
</mat-card>
